module.exports = __webpack_public_path__ + "static/media/icon_instruction.2b6c94c5.svg";